import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getContactUsDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  corporatePageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
  ],
  corporatePageContent: [
    // === CONTACT TITLE ===
    {
      fieldName: "Contact Title (EN)",
      fieldValue: "data.contactInfoHeading",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_contactInfoHeading",
      formType: "input",
      label: "Contact Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Contact Title (MS)",
      fieldValue: "data.contactInfoHeading",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_contactInfoHeading",
      formType: "input",
      label: "Contact Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Contact Title (ZH)",
      fieldValue: "data.contactInfoHeading",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_contactInfoHeading",
      formType: "input",
      label: "Contact Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },

    // === MAP COORDINATES ===
    {
      fieldName: "Latitude (EN)",
      fieldValue: "data.map.coordinates.lat",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_lat",
      formType: "input",
      label: "Latitude (EN)",
      placeholder: "Enter Latitude (EN)",
      validation: { required: "Latitude (EN) is required" },
    },
    {
      fieldName: "Latitude (MS)",
      fieldValue: "data.map.coordinates.lat",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_lat",
      formType: "input",
      label: "Latitude (MS)",
      placeholder: "Enter Latitude (MS)",
    },
    {
      fieldName: "Latitude (ZH)",
      fieldValue: "data.map.coordinates.lat",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_lat",
      formType: "input",
      label: "Latitude (ZH)",
      placeholder: "Enter Latitude (ZH)",
    },
    {
      fieldName: "Longitude (EN)",
      fieldValue: "data.map.coordinates.lng",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_lng",
      formType: "input",
      label: "Longitude (EN)",
      placeholder: "Enter Longitude (EN)",
      validation: { required: "Longitude (EN) is required" },
    },
    {
      fieldName: "Longitude (MS)",
      fieldValue: "data.map.coordinates.lng",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_lng",
      formType: "input",
      label: "Longitude (MS)",
      placeholder: "Enter Longitude (MS)",
    },
    {
      fieldName: "Longitude (ZH)",
      fieldValue: "data.map.coordinates.lng",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_lng",
      formType: "input",
      label: "Longitude (ZH)",
      placeholder: "Enter Longitude (ZH)",
    },

    // === CONTACT: PHONE ===
    {
      fieldName: "Contact Phone Title (EN)",
      fieldValue: "data.contact[0].title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_phn_title",
      formType: "input",
      label: "Contact Phone Title (EN)",
      placeholder: "Enter Phone Title (EN)",
      validation: { required: "Phone Title (EN) is required" },
    },
    {
      fieldName: "Contact Phone Image (EN)",
      fieldValue: "data.contact[0].image",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "image",
      name: "field_content_english_phn_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Phone Image (EN)",
      placeholder: "Upload Phone Image (EN)",
      validation: { required: "Phone Image (EN) is required" },
    },
    {
      fieldName: "Telephone Number (EN)",
      fieldValue: "data.contact[0].description",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_phn_description",
      formType: "input",
      label: "Telephone (EN)",
      placeholder: "Enter Telephone (EN)",
      validation: { required: "Telephone Number (EN) is required" },
    },
    {
      fieldName: "Contact Phone Title (MS)",
      fieldValue: "data.contact[0].title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_phn_title",
      formType: "input",
      label: "Contact Phone Title (MS)",
      placeholder: "Enter Phone Title (MS)",
    },
    {
      fieldName: "Contact Phone Image (MS)",
      fieldValue: "data.contact[0].image",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "image",
      name: "field_content_malay_phn_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Phone Image (MS)",
      placeholder: "Upload Phone Image (MS)",
    },
    {
      fieldName: "Telephone Number (MS)",
      fieldValue: "data.contact[0].description",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_phn_description",
      formType: "input",
      label: "Telephone (MS)",
      placeholder: "Enter Telephone (MS)",
    },
    {
      fieldName: "Contact Phone Title (ZH)",
      fieldValue: "data.contact[0].title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_phn_title",
      formType: "input",
      label: "Contact Phone Title (ZH)",
      placeholder: "Enter Phone Title (ZH)",
    },
    {
      fieldName: "Contact Phone Image (ZH)",
      fieldValue: "data.contact[0].image",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "image",
      name: "field_content_mandarin_phn_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Phone Image (ZH)",
      placeholder: "Upload Phone Image (ZH)",
    },
    {
      fieldName: "Telephone Number (ZH)",
      fieldValue: "data.contact[0].description",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_phn_description",
      formType: "input",
      label: "Telephone (ZH)",
      placeholder: "Enter Telephone (ZH)",
    },

    // === CONTACT: FAX ===
    {
      fieldName: "Contact Fax Title (EN)",
      fieldValue: "data.contact[1].title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_fax_title",
      formType: "input",
      label: "Contact Fax Title (EN)",
      placeholder: "Enter Fax Title (EN)",
        validation: { required: "Fax Title (EN) is required" },

    },
    {
      fieldName: "Contact Fax Image (EN)",
      fieldValue: "data.contact[1].image",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "image",
      name: "field_content_english_fax_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Fax Image (EN)",
      placeholder: "Upload Fax Image (EN)",
        validation: { required: "Fax Image (EN) is required" },
    },
    {
      fieldName: "Fax Number (EN)",
      fieldValue: "data.contact[1].description",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_fax_description",
      formType: "input",
      label: "Fax Number (EN)",
      placeholder: "Enter Fax Number (EN)",
        validation: { required: "Fax Number (EN) is required" },
    },
    {
      fieldName: "Contact Fax Title (MS)",
      fieldValue: "data.contact[1].title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_fax_title",
      formType: "input",
      label: "Contact Fax Title (MS)",
      placeholder: "Enter Fax Title (MS)",
    },
    {
      fieldName: "Contact Fax Image (MS)",
      fieldValue: "data.contact[1].image",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "image",
      name: "field_content_malay_fax_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Fax Image (MS)",
      placeholder: "Upload Fax Image (MS)",
    },
    {
      fieldName: "Fax Number (MS)",
      fieldValue: "data.contact[1].description",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_fax_description",
      formType: "input",
      label: "Fax Number (MS)",
      placeholder: "Enter Fax Number (MS)",
    },
    {
      fieldName: "Contact Fax Title (ZH)",
      fieldValue: "data.contact[1].title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_fax_title",
      formType: "input",
      label: "Contact Fax Title (ZH)",
      placeholder: "Enter Fax Title (ZH)",
    },
    {
      fieldName: "Contact Fax Image (ZH)",
      fieldValue: "data.contact[1].image",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "image",
      name: "field_content_mandarin_fax_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Fax Image (ZH)",
      placeholder: "Upload Fax Image (ZH)",
    },
    {
      fieldName: "Fax Number (ZH)",
      fieldValue: "data.contact[1].description",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_fax_description",
      formType: "input",
      label: "Fax Number (ZH)",
      placeholder: "Enter Fax Number (ZH)",
    },

    // === CONTACT: EMAIL ===
    {
      fieldName: "Contact Email Title (EN)",
      fieldValue: "data.contact[2].title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_email_title",
      formType: "input",
      label: "Contact Email Title (EN)",
      placeholder: "Enter Email Title (EN)",
        validation: { required: "Email Title (EN) is required" },
    },
    {
      fieldName: "Contact Email Image (EN)",
      fieldValue: "data.contact[2].image",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "image",
      name: "field_content_english_email_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Email Image (EN)",
      placeholder: "Upload Email Image (EN)",
      validation: { required: "Email Image (EN) is required" },
    },
    {
      fieldName: "Email Address (EN)",
      fieldValue: "data.contact[2].description",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_email_description",
      formType: "input",
      label: "Email Address (EN)",
      placeholder: "Enter Email Address (EN)",
       validation: { required: "Email Address (EN) is required" },
    },
    {
      fieldName: "Contact Email Title (MS)",
      fieldValue: "data.contact[2].title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_email_title",
      formType: "input",
      label: "Contact Email Title (MS)",
      placeholder: "Enter Email Title (MS)",
    },
    {
      fieldName: "Contact Email Image (MS)",
      fieldValue: "data.contact[2].image",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "image",
      name: "field_content_malay_email_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Email Image (MS)",
      placeholder: "Upload Email Image (MS)",
    },
    {
      fieldName: "Email Address (MS)",
      fieldValue: "data.contact[2].description",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_email_description",
      formType: "input",
      label: "Email Address (MS)",
      placeholder: "Enter Email Address (MS)",
    },
    {
      fieldName: "Contact Email Title (ZH)",
      fieldValue: "data.contact[2].title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_email_title",
      formType: "input",
      label: "Contact Email Title (ZH)",
      placeholder: "Enter Email Title (ZH)",
    },
    {
      fieldName: "Contact Email Image (ZH)",
      fieldValue: "data.contact[2].image",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "image",
      name: "field_content_mandarin_email_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Email Image (ZH)",
      placeholder: "Upload Email Image (ZH)",
    },
    {
      fieldName: "Email Address (ZH)",
      fieldValue: "data.contact[2].description",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_email_description",
      formType: "input",
      label: "Email Address (ZH)",
      placeholder: "Enter Email Address (ZH)",
    },

    // === ADDRESS ===
    {
      fieldName: "Address (EN)",
      fieldValue: "data.adressMarkup",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_adressMarkup",
      formType: "richText",
      label: "Address (EN)",
      placeholder: "Enter Address (EN)",
        validation: { required: "Address (EN) is required" },
    },
    {
      fieldName: "Address (MS)",
      fieldValue: "data.adressMarkup",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_adressMarkup",
      formType: "richText",
      label: "Address (MS)",
      placeholder: "Enter Address (MS)",
    },
    {
      fieldName: "Address (ZH)",
      fieldValue: "data.adressMarkup",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_adressMarkup",
      formType: "richText",
      label: "Address (ZH)",
      placeholder: "Enter Address (ZH)",
    },

    // === NEXT PAGE ===
    // {
    //   fieldName: "Next Page Name (EN)",
    //   fieldValue: "data.nextPage.name",
    //   parseField: "field_content_english",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_english_next_pageName",
    //   formType: "input",
    //   label: "Next Page Name (EN)",
    //   placeholder: "Enter Next Page Name (EN)",
    //    validation: { required: "Next Page Name (EN) is required" },
    // },
    // {
    //   fieldName: "Next Page Name (MS)",
    //   fieldValue: "data.nextPage.name",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_malay_next_pageName",
    //   formType: "input",
    //   label: "Next Page Name (MS)",
    //   placeholder: "Enter Next Page Name (MS)",
    // },
    // {
    //   fieldName: "Next Page Name (ZH)",
    //   fieldValue: "data.nextPage.name",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_mandarin_next_pageName",
    //   formType: "input",
    //   label: "Next Page Name (ZH)",
    //   placeholder: "Enter Next Page Name (ZH)",
    // },
    // {
    //   fieldName: "Next Page Link (EN)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_english",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_english_next_pageLink",
    //   formType: "input",
    //   label: "Next Page Link (EN)",
    //   placeholder: "Enter Next Page Link (EN)",
    //   validation: { required: "Next Page Link (EN) is required" },
    // },
    // {
    //   fieldName: "Next Page Link (MS)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_malay_next_pageLink",
    //   formType: "input",
    //   label: "Next Page Link (MS)",
    //   placeholder: "Enter Next Page Link (MS)",
    // },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_mandarin_next_pageLink",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    // },
  ],
  corporateMap: [
    // === CONTACT TITLE ===
    {
      fieldName: "Contact Title (EN)",
      fieldValue: "data.contactInfoHeading",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_contactInfoHeading",
      formType: "input",
      label: "Contact Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Contact Title (MS)",
      fieldValue: "data.contactInfoHeading",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_contactInfoHeading",
      formType: "input",
      label: "Contact Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Contact Title (ZH)",
      fieldValue: "data.contactInfoHeading",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_contactInfoHeading",
      formType: "input",
      label: "Contact Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },

    // === MAP COORDINATES ===
    {
      fieldName: "Latitude (EN)",
      fieldValue: "data.map.coordinates.lat",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_lat",
      formType: "input",
      label: "Latitude (EN)",
      placeholder: "Enter Latitude (EN)",
      validation: { required: "Latitude (EN) is required" },
    },
    {
      fieldName: "Latitude (MS)",
      fieldValue: "data.map.coordinates.lat",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_lat",
      formType: "input",
      label: "Latitude (MS)",
      placeholder: "Enter Latitude (MS)",
    },
    {
      fieldName: "Latitude (ZH)",
      fieldValue: "data.map.coordinates.lat",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_lat",
      formType: "input",
      label: "Latitude (ZH)",
      placeholder: "Enter Latitude (ZH)",
    },
    {
      fieldName: "Longitude (EN)",
      fieldValue: "data.map.coordinates.lng",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_lng",
      formType: "input",
      label: "Longitude (EN)",
      placeholder: "Enter Longitude (EN)",
      validation: { required: "Longitude (EN) is required" },
    },
    {
      fieldName: "Longitude (MS)",
      fieldValue: "data.map.coordinates.lng",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_lng",
      formType: "input",
      label: "Longitude (MS)",
      placeholder: "Enter Longitude (MS)",
    },
    {
      fieldName: "Longitude (ZH)",
      fieldValue: "data.map.coordinates.lng",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_lng",
      formType: "input",
      label: "Longitude (ZH)",
      placeholder: "Enter Longitude (ZH)",
    },
  ],
  corporateAddress: [
    // === ADDRESS ===
    {
      fieldName: "Address (EN)",
      fieldValue: "data.adressMarkup",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_adressMarkup",
      formType: "richText",
      label: "Address (EN)",
      placeholder: "Enter Address (EN)",
        validation: { required: "Address (EN) is required" },
    },
    {
      fieldName: "Address (MS)",
      fieldValue: "data.adressMarkup",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_adressMarkup",
      formType: "richText",
      label: "Address (MS)",
      placeholder: "Enter Address (MS)",
    },
    {
      fieldName: "Address (ZH)",
      fieldValue: "data.adressMarkup",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_adressMarkup",
      formType: "richText",
      label: "Address (ZH)",
      placeholder: "Enter Address (ZH)",
    },
  ],
  corporateCommunication: [
    // === CONTACT: PHONE ===
    {
      fieldName: "Contact Phone Title (EN)",
      fieldValue: "data.contact[0].title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_phn_title",
      formType: "input",
      label: "Contact Phone Title (EN)",
      placeholder: "Enter Phone Title (EN)",
      validation: { required: "Phone Title (EN) is required" },
    },
    {
      fieldName: "Contact Phone Image (EN)",
      fieldValue: "data.contact[0].image",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "image",
      name: "field_content_english_phn_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Phone Image (EN)",
      placeholder: "Upload Phone Image (EN)",
      validation: { required: "Phone Image (EN) is required" },
    },
    {
      fieldName: "Telephone Number (EN)",
      fieldValue: "data.contact[0].description",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_phn_description",
      formType: "input",
      label: "Telephone (EN)",
      placeholder: "Enter Telephone (EN)",
      validation: { required: "Telephone Number (EN) is required" },
    },
    {
      fieldName: "Contact Phone Title (MS)",
      fieldValue: "data.contact[0].title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_phn_title",
      formType: "input",
      label: "Contact Phone Title (MS)",
      placeholder: "Enter Phone Title (MS)",
    },
    {
      fieldName: "Contact Phone Image (MS)",
      fieldValue: "data.contact[0].image",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "image",
      name: "field_content_malay_phn_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Phone Image (MS)",
      placeholder: "Upload Phone Image (MS)",
    },
    {
      fieldName: "Telephone Number (MS)",
      fieldValue: "data.contact[0].description",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_phn_description",
      formType: "input",
      label: "Telephone (MS)",
      placeholder: "Enter Telephone (MS)",
    },
    {
      fieldName: "Contact Phone Title (ZH)",
      fieldValue: "data.contact[0].title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_phn_title",
      formType: "input",
      label: "Contact Phone Title (ZH)",
      placeholder: "Enter Phone Title (ZH)",
    },
    {
      fieldName: "Contact Phone Image (ZH)",
      fieldValue: "data.contact[0].image",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "image",
      name: "field_content_mandarin_phn_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Phone Image (ZH)",
      placeholder: "Upload Phone Image (ZH)",
    },
    {
      fieldName: "Telephone Number (ZH)",
      fieldValue: "data.contact[0].description",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_phn_description",
      formType: "input",
      label: "Telephone (ZH)",
      placeholder: "Enter Telephone (ZH)",
    },

    // === CONTACT: FAX ===
    {
      fieldName: "Contact Fax Title (EN)",
      fieldValue: "data.contact[1].title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_fax_title",
      formType: "input",
      label: "Contact Fax Title (EN)",
      placeholder: "Enter Fax Title (EN)",
        validation: { required: "Fax Title (EN) is required" },

    },
    {
      fieldName: "Contact Fax Image (EN)",
      fieldValue: "data.contact[1].image",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "image",
      name: "field_content_english_fax_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Fax Image (EN)",
      placeholder: "Upload Fax Image (EN)",
        validation: { required: "Fax Image (EN) is required" },
    },
    {
      fieldName: "Fax Number (EN)",
      fieldValue: "data.contact[1].description",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_fax_description",
      formType: "input",
      label: "Fax Number (EN)",
      placeholder: "Enter Fax Number (EN)",
        validation: { required: "Fax Number (EN) is required" },
    },
    {
      fieldName: "Contact Fax Title (MS)",
      fieldValue: "data.contact[1].title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_fax_title",
      formType: "input",
      label: "Contact Fax Title (MS)",
      placeholder: "Enter Fax Title (MS)",
    },
    {
      fieldName: "Contact Fax Image (MS)",
      fieldValue: "data.contact[1].image",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "image",
      name: "field_content_malay_fax_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Fax Image (MS)",
      placeholder: "Upload Fax Image (MS)",
    },
    {
      fieldName: "Fax Number (MS)",
      fieldValue: "data.contact[1].description",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_fax_description",
      formType: "input",
      label: "Fax Number (MS)",
      placeholder: "Enter Fax Number (MS)",
    },
    {
      fieldName: "Contact Fax Title (ZH)",
      fieldValue: "data.contact[1].title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_fax_title",
      formType: "input",
      label: "Contact Fax Title (ZH)",
      placeholder: "Enter Fax Title (ZH)",
    },
    {
      fieldName: "Contact Fax Image (ZH)",
      fieldValue: "data.contact[1].image",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "image",
      name: "field_content_mandarin_fax_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Fax Image (ZH)",
      placeholder: "Upload Fax Image (ZH)",
    },
    {
      fieldName: "Fax Number (ZH)",
      fieldValue: "data.contact[1].description",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_fax_description",
      formType: "input",
      label: "Fax Number (ZH)",
      placeholder: "Enter Fax Number (ZH)",
    },

    // === CONTACT: EMAIL ===
    {
      fieldName: "Contact Email Title (EN)",
      fieldValue: "data.contact[2].title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_email_title",
      formType: "input",
      label: "Contact Email Title (EN)",
      placeholder: "Enter Email Title (EN)",
        validation: { required: "Email Title (EN) is required" },
    },
    {
      fieldName: "Contact Email Image (EN)",
      fieldValue: "data.contact[2].image",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "image",
      name: "field_content_english_email_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Email Image (EN)",
      placeholder: "Upload Email Image (EN)",
      validation: { required: "Email Image (EN) is required" },
    },
    {
      fieldName: "Email Address (EN)",
      fieldValue: "data.contact[2].description",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_email_description",
      formType: "input",
      label: "Email Address (EN)",
      placeholder: "Enter Email Address (EN)",
       validation: { required: "Email Address (EN) is required" },
    },
    {
      fieldName: "Contact Email Title (MS)",
      fieldValue: "data.contact[2].title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_email_title",
      formType: "input",
      label: "Contact Email Title (MS)",
      placeholder: "Enter Email Title (MS)",
    },
    {
      fieldName: "Contact Email Image (MS)",
      fieldValue: "data.contact[2].image",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "image",
      name: "field_content_malay_email_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Email Image (MS)",
      placeholder: "Upload Email Image (MS)",
    },
    {
      fieldName: "Email Address (MS)",
      fieldValue: "data.contact[2].description",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_email_description",
      formType: "input",
      label: "Email Address (MS)",
      placeholder: "Enter Email Address (MS)",
    },
    {
      fieldName: "Contact Email Title (ZH)",
      fieldValue: "data.contact[2].title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_email_title",
      formType: "input",
      label: "Contact Email Title (ZH)",
      placeholder: "Enter Email Title (ZH)",
    },
    {
      fieldName: "Contact Email Image (ZH)",
      fieldValue: "data.contact[2].image",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "image",
      name: "field_content_mandarin_email_image",
      usedFileType: "image/*",
      formType: "file",
      label: "Email Image (ZH)",
      placeholder: "Upload Email Image (ZH)",
    },
    {
      fieldName: "Email Address (ZH)",
      fieldValue: "data.contact[2].description",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_email_description",
      formType: "input",
      label: "Email Address (ZH)",
      placeholder: "Enter Email Address (ZH)",
    },
  ],

  airportsPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  corporateNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_pageName", // ✅ underscore instead of dot
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter content for Next Page Name (EN)",
      validation: { required: "Content for Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_next_pageName", // ✅ underscore
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter content for Next Page Name (MS)",
      // validation: { required: "Content for Next Page Name (MS) is required" },
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_next_pageName", // ✅ underscore
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter content for Next Page Name (ZH)",
      // validation: { required: "Content for Next Page Name (ZH) is required" },
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_next_pageLink", // ✅ underscore
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter content for Next Page Link",
      validation: {
        required: "Content for Next Page Link is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
          if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
            return "Looks like an external link. Please use an in-app page link, such as /example";
          }
          return true;
        },
      },
    },
  ],
};
